import { writable } from 'svelte/store';

export const defaultState = {
    allIds: [
        'apam_kollegaja',
        'apam_udvarolt',
        'bandi_mica',
        'bice_rossi',
        'dr_reiss_arthur',
        'fortune_maestro',
        'giulio_hertz',
        'herczeg_gyulane_maestro_irene',
        'herczeg_ilona',
        'hertz_jolan',
        'herz_janka',
        'irene_maestro',
        'jolan_hertz',
        'patkai_rozina',
        'rado_armin_jolan_tibi',
        'rado_jolan',
        'rado_tibi',
        'reisz_antal_barany_aranka',
        'reisz_toni',
        'revesz_alexander',
        'revesz_felix',
        'schwarz_gizka_imre_gyuri',
        'schwarz_imre',
        'schwarz_imre_gyorgy_csoportkep',
        'schwarz_imre_losonczi_csoportkep',
        'schwarz_kalman_gizka_herz',
        'schwarz_kalman_gizka_zagrab',
        'schwarz_laci',
        'szerena'
    ],
    byIds: {
        apam_kollegaja: {
            id: 'apam_kollegaja',
            frontImgPath: './images/cards/front/apam_kollegaja_front_thumbnail.jpg',
            backImgPath: './images/cards/back/apam_kollegaja_back_highres.jpg',
            isSurvivor: true
        },
        apam_udvarolt: {
            id: 'apam_udvarolt',
            frontImgPath: './images/cards/front/apam_udvarolt_front_thumbnail.jpg',
            backImgPath: './images/cards/back/apam_udvarolt_back_highres.jpg',
            isSurvivor: true,
        },
        bandi_mica: {
            id: 'bandi_mica',
            frontImgPath: './images/cards/front/bandi_mica_front_thumbnail.jpg',
            backImgPath: './images/cards/back/bandi_mica_back_highres.jpg',
            isSurvivor: false,
            isHorizontal: true
        },
        bice_rossi: {
            id: 'bice_rossi',
            frontImgPath: './images/cards/front/bice_rossi_front_thumbnail.jpg',
            backImgPath: './images/cards/back/bice_rossi_back_highres.jpg',
            isSurvivor: false,
        },
        dr_reiss_arthur: {
            id: 'dr_reiss_arthur',
            frontImgPath: './images/cards/front/dr_reiss_arthur_front_thumbnail.jpg',
            backImgPath: './images/cards/back/dr_reiss_arthur_back_highres.jpg',
            isSurvivor: false,
        },
        fortune_maestro: {
            id: 'fortune_maestro',
            frontImgPath: './images/cards/front/fortune_maestro_1932_front_thumbnail.jpg',
            backImgPath: './images/cards/back/fortune_maestro_1932_back_highres.jpg',
            isSurvivor: true,
        },
        giulio_hertz: {
            id: 'giulio_hertz',
            frontImgPath: './images/cards/front/giulio_hertz_front_thumbnail.jpg',
            backImgPath: './images/cards/back/giulio_hertz_back_highres.jpg',
            isSurvivor: true,
        },
        herczeg_gyulane_maestro_irene: {
            id: 'herczeg_gyulane_maestro_irene',
            frontImgPath: './images/cards/front/herczeg_gyulane_maestro_irene_front_thumbnail.jpg',
            backImgPath: './images/cards/back/herczeg_gyulane_maestro_irene_back_highres.jpg',
            isSurvivor: true,
        },
        herczeg_ilona: {
            id: 'herczeg_ilona',
            frontImgPath: './images/cards/front/herczeg_ilona_front_thumbnail.jpg',
            backImgPath: './images/cards/back/herczeg_ilona_back_highres.jpg',
            isSurvivor: true,
        },
        hertz_jolan: {
            id: 'hertz_jolan',
            frontImgPath: './images/cards/front/hertz_jolan_front_thumbnail.jpg',
            backImgPath: './images/cards/back/hertz_jolan_back_highres.jpg',
            isSurvivor: false,
        },
        herz_janka: {
            id: 'herz_janka',
            frontImgPath: './images/cards/front/herz_janka_front_thumbnail.jpg',
            backImgPath: './images/cards/back/herz_janka_back_highres.jpg',
            isSurvivor: true,
        },
        irene_maestro: {
            id: 'irene_maestro',
            frontImgPath: './images/cards/front/irene_maestro_1900_front_thumbnail.jpg',
            backImgPath: './images/cards/back/irene_maestro_1900_back_highres.jpg',
            isSurvivor: true,
        },
        jolan_hertz: {
            id: 'jolan_hertz',
            frontImgPath: './images/cards/front/jolan_hertz_front_thumbnail.jpg',
            backImgPath: './images/cards/back/jolan_hertz_back_highres.jpg',
            isSurvivor: true,
        },
        patkai_rozina: {
            id: 'patkai_rozina',
            frontImgPath: './images/cards/front/patkai_rozina_front_thumbnail.jpg',
            backImgPath: './images/cards/back/patkai_rozina_back_highres.jpg',
            isSurvivor: true,
        },
        rado_armin_jolan_tibi: {
            id: 'rado_armin_jolan_tibi',
            frontImgPath: './images/cards/front/rado_armin_jolan_tibi_front_thumbnail.jpg',
            backImgPath: './images/cards/back/rado_armin_jolan_tibi_back_highres.jpg',
            isSurvivor: false,
        },
        rado_jolan: {
            id: 'rado_jolan',
            frontImgPath: './images/cards/front/rado_jolan_front_thumbnail.jpg',
            backImgPath: './images/cards/back/rado_jolan_back_highres.jpg',
            isSurvivor: false,
        },
        rado_tibi: {
            id: 'rado_tibi',
            frontImgPath: './images/cards/front/rado_tibi_front_thumbnail.jpg',
            backImgPath: './images/cards/back/rado_tibi_back_highres.jpg',
            isSurvivor: false,
        },
        reisz_antal_barany_aranka: {
            id: 'reisz_antal_barany_aranka',
            frontImgPath: './images/cards/front/reisz_antal_barany_aranka_front_thumbnail.jpg',
            backImgPath: './images/cards/back/reisz_antal_barany_aranka_back_highres.jpg',
            isSurvivor: true,
        },
        reisz_toni: {
            id: 'reisz_toni',
            frontImgPath: './images/cards/front/reisz_toni_front_thumbnail.jpg',
            backImgPath: './images/cards/back/reisz_toni_back_highres.jpg',
            isSurvivor: true,
        },
        revesz_alexander: {
            id: 'revesz_alexander',
            frontImgPath: './images/cards/front/revesz_alexander_front_thumbnail.jpg',
            backImgPath: './images/cards/back/revesz_alexander_back_highres.jpg',
            isSurvivor: false,
        },
        revesz_felix: {
            id: 'revesz_felix',
            frontImgPath: './images/cards/front/revesz_felix_front_thumbnail.jpg',
            backImgPath: './images/cards/back/revesz_felix_back_highres.jpg',
            isSurvivor: false,
        },
        schwarz_gizka_imre_gyuri: {
            id: 'schwarz_gizka_imre_gyuri',
            frontImgPath: './images/cards/front/schwarz_gizka_imre_gyuri_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_gizka_imre_gyuri_back_highres.jpg',
            isSurvivor: false,
        },
        schwarz_imre: {
            id: 'schwarz_imre',
            frontImgPath: './images/cards/front/schwarz_imre_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_imre_back_highres.jpg',
            isSurvivor: false,
        },
        schwarz_imre_gyorgy_csoportkep: {
            id: 'schwarz_imre_gyorgy_csoportkep',
            frontImgPath: './images/cards/front/schwarz_imre_gyorgy_csoportkep_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_imre_gyorgy_csoportkep_back_highres.jpg',
            isSurvivor: false,
            isHorizontal: true
        },
        schwarz_imre_losonczi_csoportkep: {
            id: 'schwarz_imre_losonczi_csoportkep',
            frontImgPath: './images/cards/front/schwarz_imre_gyorgy_losonczi_csoportkep_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_imre_gyorgy_losonczi_csoportkep_back_highres.jpg',
            isSurvivor: false,
            isHorizontal: true
        },
        schwarz_kalman_gizka_herz: {
            id: 'schwarz_kalman_gizka_herz',
            frontImgPath: './images/cards/front/schwarz_kalman_gizka_herz_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_kalman_gizka_herz_back_highres.jpg',
            isSurvivor: false,
        },
        schwarz_kalman_gizka_zagrab: {
            id: 'schwarz_kalman_gizka_zagrab',
            frontImgPath: './images/cards/front/schwarz_kalman_gizka_zagrab_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_kalman_gizka_zagrab_back_highres.jpg',
            isSurvivor: false,
        },
        
        schwarz_laci: {
            id: 'schwarz_laci',
            frontImgPath: './images/cards/front/schwarz_laci_front_thumbnail.jpg',
            backImgPath: './images/cards/back/schwarz_laci_back_highres.jpg',
            isSurvivor: false,
        },
        szerena: {
            id: 'szerena',
            frontImgPath: './images/cards/front/szerena_front_thumbnail.jpg',
            backImgPath: './images/cards/back/szerena_back_highres.jpg',
            isSurvivor: true,
        },
    },
    frontImagesOrder: [],
    backImagesOrder: [],
    matchedImages: [],
    selectedFrontImage: undefined,
    selectedBackImage: undefined,
    isFinalSceneActive: false
};

export const state = writable(defaultState);